export const EMPTY_PROSPECTING_CONTACT = {
  name: "",
  job_title: "",
  email: "",
  work_phone: "",
  mobile_phone: "",
  linkedin: "",
  notes: "",
  company: null,
  city: "",
  state: "",
  country: "",
};

export const buildProspectingCompanySelection = (company) => {
  if (!company?.id) {
    return null;
  }

  return {
    id: company.id,
    name: company.name || "",
    source: "prospecting",
  };
};

export const mergeLocationIfEmpty = (contact, locationSource) => {
  if (contact.city || contact.state || contact.country) {
    return contact;
  }

  return {
    ...contact,
    city: locationSource?.city || "",
    state: locationSource?.state || "",
    country: locationSource?.country || "",
  };
};

export const mapProspectingContactToForm = (contact) => {
  const company = buildProspectingCompanySelection(contact?.company);

  return mergeLocationIfEmpty(
    {
      ...EMPTY_PROSPECTING_CONTACT,
      name: contact?.full_name ?? "",
      job_title: contact?.job_title ?? "",
      email: contact?.email ?? "",
      work_phone: contact?.work_phone ?? contact?.phone ?? "",
      mobile_phone: contact?.mobile_phone ?? "",
      linkedin: contact?.linkedin ?? "",
      notes: contact?.notes ?? "",
      city: contact?.city || "",
      state: contact?.state || "",
      country: contact?.country || "",
      company,
    },
    contact?.company,
  );
};

export const buildProspectingContactPayload = (contact) => ({
  full_name: contact.name || null,
  job_title: contact.job_title || null,
  email: contact.email || null,
  work_phone: contact.work_phone || null,
  mobile_phone: contact.mobile_phone || null,
  phone: contact.work_phone || null,
  linkedin: contact.linkedin || null,
  notes: contact.notes || null,
  prospecting_company_id: contact.company.id,
  city: contact.city || null,
  state: contact.state || null,
  country: contact.country || null,
});
